import { pick } from 'ramda'
import { useMutation, gql } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { getValidations } from '../_helpers/validations'
import { accountsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpdatePassword($password: String) {
    updatePassword(input: { password: $password }) {
      id
    }
  }
`

const useCreateStrongPasswordRequest = form => {
  const { t } = useTranslation('session')
  const [request, state] = useMutation(MUTATION, { client: accountsClient })
  const notify = useNotification()

  const closeModal = useCloseModal()

  const handleRequest = async e => {
    e.preventDefault()

    const validations = getValidations()
    if (!validations.every(validation => !validation.check || validation.check(form))) {
      notify.error({ title: t('createPasswordModal.checkFieldsBelow'), message: t('createPasswordModal.tryAgain') })
      return
    }

    request({ variables: pick(['password'], form) }).then(resp => {
      if (resp.errors) return
      closeModal()
    })
  }

  return [handleRequest, state]
}

export default useCreateStrongPasswordRequest
